import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 224.93 202.19' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M224.93 0H0v137.34h69.19l.49 4.37-.08.05.1.14 6.5 58.3 16.75-12 19.52 14 19.62-14.06L149 200.2l6.83-62.86h69.13zM74.22 137.34h1.56l-1.44 1zM112.48 119l14.39 10.31H95.52L109.91 119zm7.81 18.31l-7.82 5.69-7.83-5.61zm.77-18.31h24.77l-12.39 8.88zm-30.86 8l-11.12-8h22.23zm5.85 10.34l12.12 8.66L95 155.47l-18-12.86 7.35-5.27zm-5.35 21.21l-13.08 9.37-2.27-20.34zm4.3 3.07l13.23 9.46L92.94 182l-13.21-9.47zm4.29-3.08l13.17-9.44 13.21 9.47-13.14 9.43zm30.71 3.11l15.23 10.92-13.15 9.43-15.25-10.9zm4.29-3.08l15.4-11-2.25 20.43zM130 155.5l-13.24-9.5 12.12-8.69H138l8.64 6.19zm22.65-35.18l-1 9H140zM158 111H66.93V57.61H158zm-73.11 18.34H73.33l-1-9zm-4.68 61.82L78.75 178l9.9 7.09zm32.26 4.84l-15.23-10.88 15.3-11 15.25 10.9zm23.91-11l10-7.16-1.44 13.28zm14.1-44.94l-3.86-2.77h4.16zm66.46-10.77h-60.27l1.12-10.29H166V49.61H58.93V119h8.22l1.15 10.31H8V8h208.93z'
        fill='undefined'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CanestroIcon.js